import {Typography} from "@mui/material";

import {designColors, designTokens} from "~/ui";

export interface BmPageSubtitleProps {
  children: React.ReactNode;
}

export const BmPageSubtitle: React.FC<BmPageSubtitleProps> = ({children}) => {
  return (
    <Typography
      sx={{
        color: designColors.grey_5,
        fontSize: designTokens.fontSize.xsm,
        lineHeight: "16px",
      }}
    >
      {children}
    </Typography>
  );
};
